<template>
  <div class="tree-content">
    <div class="company-tree" >
      <el-tree
        class="filter-tree"
        :data="treeData"
        :props="defaultProps"
        :expand-on-click-node="false"
        @current-change="currentChange"
        :highlight-current="true"
        :default-expand-all="true"
        node-key="id"
        ref="tree">
      </el-tree>
    </div>
  </div>
</template>
<script>
export default {
  name: 'treeSelecter',
  data () {
    return {
      size: 'medium',
      filterText: '',
      visibleDept: false,
      treeLoading: false,
      deptList: [],
      expandedKeys: null,
      defaultProps: {
        children: 'children',
        label: 'measureName'
      }
    }
  },
  props: {
    treeData: {
      type: Array,
      default: []
    },
  },
  created () {
  },
  mounted () {
  },
  methods: {
    currentChange (node, el) {
      // console.log(node, el)
      this.$emit('handleChangeNode', { ...node })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
